// import renderPreviewFile from '@weights/customRender/renderPreviewFile'
// import renderEllipsisCell from '@weights/customRender/renderEllipsisCell'

import { empty as emptyFilter } from '@utils'

export const ATTENDANCE_LIST_COLUMNS = [
    {
        dataIndex: 'fullName',
        title: '姓名',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'idNumber',
        title: '身份证号',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'gender',
        title: '性别',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'teamName',
        title: '班组',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'enterpriseName',
        title: '归属单位',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'attendanceDays',
        title: '当月出勤天数',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'remark',
        title: '备注',
        width: 200,
        customRender: val => emptyFilter(val)
    }
]


export const ATTENDANCE_CONFIRM_SUC_LIST_COLUMNS = [
    {
        dataIndex: 'fullName',
        title: '姓名',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'idNumber',
        title: '身份证号',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'gender',
        title: '性别',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'age',
        title: '年龄',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'teamName',
        title: '班组',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'enterpriseName',
        title: '归属单位',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'attendanceDays',
        title: '当月出勤天数',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'stateText',
        title: '核准结果',
        width: 200,
        customRender: val => emptyFilter(val)
    }
]

export const ATTENDANCE_CONFIRM_FAIL_LIST_COLUMNS = [
    {
        dataIndex: 'fullName',
        title: '姓名',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'idNumber',
        title: '身份证号',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'gender',
        title: '性别',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'age',
        title: '年龄',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'teamName',
        title: '班组',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'enterpriseName',
        title: '归属单位',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'attendanceDays',
        title: '当月出勤天数',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'stateText',
        title: '核准结果',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'reason',
        title: '原因说明',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        key: 'action',
        title: '操作',
        width: 100,
        fixed: 'right',
        scopedSlots: {
            customRender: 'action'
        }
    }
]

export const ATTENDANCE_SALARY_UNCONFIRM_LIST_COLUMNS = [
    {
        dataIndex: 'fullName',
        title: '姓名',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'idNumber',
        title: '身份证号',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'gender',
        title: '性别',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'age',
        title: '年龄',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'teamName',
        title: '班组',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'enterpriseName',
        title: '归属单位',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'cashAdvances',
        title: '预支现金',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'wages',
        title: '应得工资',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'amountDeducted',
        title: '扣除金额',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'wagesToBePaid',
        title: '应发工资',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'stateText',
        title: '核准结果',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        dataIndex: 'reason',
        title: '原因说明',
        width: 200,
        customRender: val => emptyFilter(val)
    },
    {
        key: 'action',
        title: '操作',
        width: 100,
        fixed: 'right',
        scopedSlots: {
            customRender: 'action'
        }
    }
]


